import EnLang from "./entries/en-US";

const AppLocale = {
    en: EnLang,
  };

  export default AppLocale;